import React, { useEffect, useState } from "react";
import product from "../../assets/product.png";
import calender from "../../assets/calender.png";
import statusIcon from "../../assets/orders/status.png";
import {
  Button,
  Carousel,
  Checkbox,
  Collapse,
  message,
  Modal,
  Radio,
  Rate,
  Space,
} from "antd";
import GroupOrder from "../../assets/GroupOrder.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import note from "../../assets/preview/note.png";
import build from "../../assets/previewRequests/build.png";
import size from "../../assets/previewRequests/size.png";
import door from "../../assets/previewRequests/door.png";
import floors from "../../assets/previewRequests/floors.png";
import prev from "../../assets/previewRequests/prev.png";
import time from "../../assets/previewRequests/time.png";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateOrderFunction } from "../../redux/orderUpdateSlice";
import { updatePreviewFunction } from "../../redux/previewsUpdateSlice";
import { fetchPreviewId } from "../../redux/showPreviewIdSlice";
import check from "../../assets/orders/check.png";
import cancelled from "../../assets/orders/cancelled.png";
import { fetchCompanyData } from "../../redux/companyDataSlice";
import {
  acceptOfferFunction,
  payWalletFunction,
  refuseOfferFunction,
} from "../../redux/acceptOfferSlice";
import { useTranslation } from "react-i18next";

const PreviewRequestsPending = ({
  id,
  isoDate,
  statuss,
  description,
  addresss,
  area,
  levels_count,
  units_count,
  construction_type,
  preprices,
  used_technologys,
  dateV,
  timeV,
  // adminData,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalView, setIsModalView] = useState(false);
  const [isModalCancel, setIsModalCancel] = useState(false);
  const [isModalOffers, setIsModalOffers] = useState(false);

  const [currentOrder, setCurrentOrder] = useState(null);

  const dispatch = useDispatch();

  // const showModal = () => {
  //   setIsModalOpen(true);
  // };

  const showModal = async () => {
    await dispatch(fetchPreviewId(id));
    setCurrentOrder(showPreviewId);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const showModalCancel = () => {
    setIsModalCancel(true);
  };
  const handleOkCancel = () => {
    setIsModalCancel(false);
  };
  const handleCancelCancel = () => {
    setIsModalCancel(false);
  };

  const showModalOffers = () => {
    setIsModalOffers(true);
  };
  const handleOkOffers = () => {
    setIsModalOffers(false);
  };
  const handleCancelOffers = () => {
    setIsModalOffers(false);
  };

  const [value, setValue] = useState("No reason");

  const [collapsed, setCollapsed] = useState(false);
  let [open, setOpen] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    {
      collapsed ? <DownOutlined /> : <UpOutlined />;
    }
  };
  const customExpandIcon = ({ isActive }) =>
    isActive ? (
      <UpOutlined className="plus-icon mt-4" />
    ) : (
      <DownOutlined className="plus-icon mt-4" />
    );

  const { showPreviewId, status, error } = useSelector(
    (state) => state.showPreviewId
  );

  const [walletPay, setWalletPay] = useState(0);
  const [walletError, setWalletError] = useState("");

  const onChangeWallet = (e) => {
    const checked = e.target.checked;
    console.log("Use my wallet:", checked);
    setWalletPay(checked ? 1 : 0);
    if (!checked) {
      setWalletError("");
    }
  };

  const handleAccept = async (e, offer) => {
    e.preventDefault();

    const payload = {
      construction_preview_id: offer.construction_preview_id,
      company_id: offer.service_provider_id || offer.agent_id,
      device: "web",
      wallete_pay: walletPay,
    };

    const paydata = {
      construction_preview_id: offer.construction_preview_id,
      type: "deposit",
    };

    try {
      const result = await dispatch(acceptOfferFunction(payload)).unwrap();
      console.log(t("Payment response"), result);

      if (walletPay == 1) {
        dispatch(payWalletFunction(paydata));
        message.success(t("Payment successful"));
      } else {
        if (result.payment_url) {
          window.open(result.payment_url, "_blank");
        } else {
          console.error(t("Payment URL not found in the response."));
        }
      }
    } catch (error) {
      console.error(t("Payment failed"), error);
    }
  };

  const dateObject = new Date(isoDate);

  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const year = dateObject.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  const hours = dateObject.getHours();
  const minutes = dateObject.getMinutes();

  const formattedTime = `${hours}:${minutes}`;

  // const items = [
  //   {
  //     key: "1",
  //     label: (
  //       <>
  //         <p className="text-[#929AA8]">30 mins</p>
  //         <h3 className="text-[#525D71] font-semibold">Offering number 1</h3>
  //       </>
  //     ),
  //     children: (
  //       <div>
  //         <h3 className="text-[#14294F] text-lg font-semibold">Description:</h3>
  //         <p className="text-[#737E91] mt-3 font-semibold">
  //           Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
  //           eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
  //           ad minim veniam, quis nostrud exercitation ullamco. Lorem ipsum
  //           dolor sit amet, consectetur adipiscing.
  //         </p>

  //         <div className="lg:flex justify-center items-center my-5">
  //           <div>
  //             <Rate allowHalf defaultValue={4} className="" />
  //             <p className="text-[#283D63] mt-2 font-semibold">
  //               30 years in business
  //             </p>
  //           </div>
  //           <div className="flex items-center lg:ml-10 max-lg:mt-3">
  //             <img src={time} className="w-[40px]" />
  //             <p className="text-[#283D63] font-semibold ml-4">
  //               Usually replies <br /> within minutes
  //             </p>
  //           </div>
  //         </div>

  //         <div className="lg:flex items-center">
  //           <p className="text-[#283D63] font-semibold text-lg">
  //             Technologies:
  //           </p>
  //           <div className="flex items-center">
  //             <div className="text-[#FE9B71] rounded-full font-semibold border-2 border-[#FE9B71] px-5 py-1 mt-5 mb-5 flex mx-auto lg:ml-4">
  //               Accent chairs
  //             </div>

  //             <div className="text-[#FE9B71] rounded-full font-semibold border-2 border-[#FE9B71] px-5 py-1 mt-5 mb-5 flex mx-auto ml-4">
  //               Accent chairs
  //             </div>

  //             <div className="text-[#FE9B71] rounded-full font-semibold border-2 border-[#FE9B71] px-5 py-1 mt-5 mb-5 flex mx-auto ml-4">
  //               Accent chairs
  //             </div>
  //           </div>
  //         </div>

  //         <div className="bg-[#FCFBFA] rounded-2xl font-medium w-[300px] p-5 mx-auto text-lg mt-3">
  //           <h3 className="text-[#525D71] text-xl">Preview Cost</h3>
  //           <div className="flex items-center justify-between">
  //             <div>
  //               <p className="text-[#A4ADBC] mt-3">Price</p>
  //               <p className="text-[#FE9B71]">560 SAR</p>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     ),
  //   },
  // ];

  console.log(preprices);

  const items = preprices.map((offer, index) => {
    const adminData = offer.company?.admin || [];

    return {
      key: offer.id.toString(),
      label: (
        <div className="relative">
          {/* <p className="text-[#929AA8]">30 mins</p> */}
          <h3 className="text-[#525D71] font-semibold">
             {t("Offering number")} {index + 1}
          </h3>
          {offer.status == "new" && (
            <div className="bg-[#F8B69A] text-white text-xl rounded-xl px-7 py-2 absolute right-0 -top-7">
               {t("New")}
            </div>
          )}
        </div>
      ),
      children: (
        <div>
          <Checkbox
            onChange={onChangeWallet}
            className="text-[#283D63] font-medium text-lg my-4 flex mx-auto justify-center"
          >
             {t("Use my wallet to pay 10%")}
          </Checkbox>
          <div className="flex justify-between items-center mb-5">
            <div className="flex space-x-3">
              <button
                onClick={(e) => handleAccept(e, offer)}
                className="text-white px-4 py-2 rounded"
                aria-label="Accept Offer"
              >
                <img src={check} className="w-[40px]" alt="accept icon" />
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(
                    refuseOfferFunction({
                      construction_preview_id: offer.construction_preview_id,
                      company_id: offer.service_provider_id || offer.agent_id,
                      device: "web",
                    })
                  );
                }}
                className="text-white px-4 py-2 rounded"
              >
                <img src={cancelled} className="w-[40px]" alt="reject icon" />
              </button>
            </div>
          </div>

          <h3 className="text-[#14294F] text-lg font-semibold"> {t("Description")}</h3>
          <p className="text-[#737E91] mt-3 font-semibold">
            {language == "en" ? adminData?.desc_en : adminData?.desc_ar}
          </p>

          <div className="lg:flex justify-center items-center my-5">
            <div>
              <Rate allowHalf defaultValue={adminData.rates} />
              <p className="text-[#283D63] mt-2 font-semibold">
                {offer.businessYears}
              </p>
            </div>
            <div className={`flex items-center ${language == "en" ? "lg:ml-10" : "lg:mr-10"} max-lg:mt-3`}>
              <img src={time} className="w-[40px]" alt="time icon" />
              <p className={`text-[#283D63] font-semibold ${language == "en" ? "ml-4" : "mr-4"}`}>
                 {t("Usually replies")} <br /> {t("within minutes")}
              </p>
            </div>
          </div>

          <div className="lg:flex items-center">
            <p className="text-[#283D63] font-semibold text-lg">
               {t("Technologies:")}
            </p>
            <div className="flex items-center flex-wrap">
              {used_technologys?.flat().map((tech, index) => (
                <div
                  key={index}
                  className="text-[#FE9B71] rounded-full font-semibold border-2 border-[#FE9B71] px-5 py-1 mt-5 mb-5 mx-2"
                >
                  {tech.technology}
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#FCFBFA] rounded-2xl font-medium w-[300px] p-5 mx-auto text-lg mt-3">
            <h3 className="text-[#525D71] text-xl">{t("Preview Cost")}</h3>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-[#A4ADBC] mt-3">{t("Price")}</p>
                <p className="text-[#FE9B71]">{offer.price}</p>
              </div>
            </div>
          </div>
        </div>
      ),
    };
  });

  return (
    <div>
      <div className="bg-white shadow-2xl rounded-2xl mt-4 p-4">
        <div className="flex justify-between ">
          <div className="lg:flex items-center">
            <img src={prev} className="w-[100px] rounded-2xl" />
            <p className="ml-3 text-[#737E91] font-semibold max-lg:mt-3">
              {t("Order number")}
              <span className="text-[#283D63] font-semibold">#{id}</span>
              <div className="flex items-center mt-3">
                <img
                  src={calender}
                  className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#283D63] font-medium">
                  {dateV} | {timeV}
                </p>
              </div>
              <div className="flex items-center mt-3">
                <img
                  src={statusIcon}
                  className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#737E91]">{t("Status")}</p>
                <p
                  className={`text-[#283D63] font-medium ${
                    language == "en" ? "ml-2" : "mr-2"
                  }`}
                >
                  {t("Pending")}
                </p>{" "}
              </div>
            </p>
          </div>
        </div>

        <div className="flex justify-center my-5">
          <div>
            <button
              onClick={showModal}
              className="bg-[#FE9B71] text-white rounded-full px-8 max-lg:px-3 h-10 mx-3"
            >
               {t("View request")}
            </button>
            <Modal
              title={t("Request View")}
              className="orderModal"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
            >
              <div className="mt-6">
                <img src={note} className="w-[30px] mx-auto" />
                <p className="text-[#737E91] text-lg mt-4 mx-auto text-center">
                   {t("Request is pending. Companies are reviewing your requests, check the offers page to view different company offers")}
                </p>

                <img src={prev} className="w-[120px] mx-auto my-5" />
                <div className="text-center">
                  <p className="text-[#737E91] font-semibold text-xl">
                  {t("Order number")} 
                    <span className="text-[#283D63] font-semibold">#{id}</span>
                  </p>
                  <p className="text-[#A6ADB9] mt-2">
                  {t("Order created on")} {formattedDate} <br /> {formattedTime}
                  </p>
                </div>

                <div className="px-5">
                  <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
                    <div className="flex items-center mt-3 ">
                      <img
                        src={calender}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#283D63] font-medium">
                        {formattedDate} | {formattedTime}
                      </p>
                    </div>
                    <div className="flex items-center mt-3 ">
                      <img
                        src={address}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#283D63] font-medium">{addresss}</p>
                    </div>
                  </div>

                  <div className="flex items-start mt-5 ">
                    <img
                      src={desc}
                      className={`w-[28px] ${
                        language == "en" ? "mr-2" : "ml-2"
                      }`}
                    />
                    <p className="text-[#283D63] font-medium">{description}</p>
                  </div>

                  <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
                    <div className="flex items-center mt-3 ">
                      <img
                        src={upload}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      {showPreviewId?.uploaded_images?.length > 0 ? (
                        <>
                          <button
                            onClick={showModalView}
                            className="text-[#6682B6] underline font-medium"
                          >
                            {t("View Uploaded Images")}
                          </button>
                          <Modal
                            title={t("Uploaded Images")}
                            className="orderModal orderModalPricing w_small_modal"
                            open={isModalView}
                            onOk={handleOkView}
                            onCancel={handleCancelView}
                            footer={null}
                          >
                            <Carousel
                              arrows
                              infinite={false}
                              className="custome_carousel_images"
                            >
                              {showPreviewId?.uploaded_images?.map(
                                (img, index) => (
                                  <div key={index}>
                                    <img
                                      src={`https://service.samoolah.com/${img}`}
                                      alt={`Uploaded image ${index + 1}`}
                                      className="w-[120px] mx-auto my-5"
                                    />
                                  </div>
                                )
                              )}
                            </Carousel>
                          </Modal>
                        </>
                      ) : (
                        <p className="text-[#283D63] font-medium">
                          {t("No Uploaded Images")}
                        </p>
                      )}
                    </div>
                    <div className="flex items-center mt-3 ">
                      <img
                        src={statusIcon}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#737E91] font-medium">
                        {t("Status")}
                      </p>
                      <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>
                        {statuss}
                      </p>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
                    <div className="flex items-center mt-3 ">
                      <img
                        src={build}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#737E91] font-medium">
                        {t("Property:")}
                        <span className={`text-[#283D63] ${language == "en" ? "ml-1" : "mr-1"}`}>
                          {construction_type}
                        </span>
                      </p>
                    </div>
                    <div className="flex items-center mt-3 ">
                      <img
                        src={size}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#737E91] font-medium">
                         {t("Area in square meters:")}
                      </p>
                      <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>{area}</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
                    <div className="flex items-center mt-3 ">
                      <img
                        src={floors}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#737E91] font-medium">
                         {t("Number of floors:")}
                        <span className={`text-[#283D63] ${language == "en" ? "ml-1" : "mr-1"}`}>
                          {levels_count}
                        </span>
                      </p>
                    </div>
                    <div className="flex items-center mt-3 ">
                      <img
                        src={door}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#737E91] font-medium">
                         {t("Number of apartments:")}
                      </p>
                      <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>
                        {units_count}
                      </p>
                    </div>
                  </div>
                </div>

                <button
                  onClick={showModalCancel}
                  className="text-[#FE9B71] rounded-full text-lg border-2 border-[#FE9B71] px-10 py-2 mt-10 mb-5 flex mx-auto"
                > 
                   {t("Cancel Preview")}
                </button>
                <Modal
                  title={t("Are you sure you want to cancel?")}
                  className="orderModal orderModalPricing w_small_modal"
                  open={isModalCancel}
                  onOk={handleOkCancel}
                  onCancel={handleCancelCancel}
                  footer={null}
                >
                  <form
                    className="mx-5 my-5"
                    onSubmit={(e) => {
                      e.preventDefault();
                      dispatch(
                        updatePreviewFunction({
                          status: "cancelled",
                          construction_preview_id: id,
                          cancel_reason: value,
                        })
                      );
                      setIsModalCancel(false);
                    }}
                  >
                    <p className="text-[#A6ADB9] text-center">
                       {t("No refund is available after team visit")}
                    </p>

                    <button
                      type="submit"
                      className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
                    >
                      {t("Cancel Preview")}
                    </button>
                  </form>
                </Modal>
              </div>
            </Modal>
          </div>

          <div>
            <button
              onClick={showModalOffers}
              className="text-[#FE9B71] rounded-full h-10 border-2 border-[#FE9B71] px-8 max-lg:px-3"
            >
               {t("View offers")}
            </button>

            <Modal
              title={t("Available Offers")}
              className="orderModal"
              open={isModalOffers}
              onOk={handleOkOffers}
              onCancel={handleCancelOffers}
              footer={null}
            >
              <div>
                <img src={prev} className="w-[120px] mx-auto my-5" />
                <div className="text-center">
                  <p className="text-[#737E91] font-semibold text-xl">
                  {t("Order number")} 
                    <span className="text-[#283D63] font-semibold">#{id}</span>
                  </p>
                  <p className="text-[#A6ADB9] mt-2">
                  {t("Order created on")} {formattedDate} <br /> {formattedTime}
                  </p>
                </div>

                <Collapse
                  defaultActiveKey={["1"]}
                  inlineCollapsed={collapsed}
                  items={items}
                  expandIcon={customExpandIcon}
                  expandIconPosition="right"
                  bordered={false}
                  className="bg-white custom_collapse mt-5"
                />
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewRequestsPending;
